module.exports = __webpack_public_path__ + "img/radnici.a1c68386.png";